export class Topup
{
    store_id: string;
    amount: string;    
    createdby: string;   
}


// WEBPACK FOOTER //
// /tmp/build_713add00/src/models/topupmodel.ts